import { success } from '@/utils/alert'
import { mapActions } from 'vuex'

export default {
  ...mapActions(['updateUserData']),
  doActive () {
    if (!this.user.active) {
      this.$http.put('/v1/settings/profiles/me/account_active')
      .then(({data}) => {
        this.updateUserData(data)
        success('Seja bem vindo. Sentimos sua falta, sua conta acaba de ser reativada.')
      })
      .catch(({data}) => {
        this.errors = data
      })
    }
  },
  // adcionado para olcutar ou aparecer a searchbar por kaywords para paciente
  handleScroll: function (e) {
    let currentScrollPosition = e.srcElement.scrollTop
    console.log(currentScrollPosition)
    if (currentScrollPosition > 250) {
      this.topSearchBar = true
    } else {
      this.topSearchBar = false
    }
    this.scrollPosition = currentScrollPosition
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/dashboard/gadget/resources/methods.js